
import saveAs from 'file-saver'
import writeXlsxFile from 'write-excel-file'
import getNow from '../../helpers/getNow'

const createXLS = async ({ selectedData, schema, sheetName, fileName }) => {
	const blob = await writeXlsxFile(selectedData, {
		schema,
		sheet: sheetName,
		headerStyle: {
			backgroundColor: '#eeeeee'
		}
	})
	saveAs(blob, `${fileName}__${getNow()}.xlsx`)
}

export default createXLS
